import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Inject,
  Input,
  PLATFORM_ID,
} from '@angular/core';
import { Picture } from '../../admin/shared/public-api';

@Directive({
  selector: '[appZoom]',
  standalone: true,
})
export class ZoomDirective implements AfterViewInit {
  @Input() picture: Picture | undefined;
  @Input() executeOnInit = true;
  private element: HTMLElement;
  private isBrowser = false;

  constructor(@Inject(PLATFORM_ID) platformId: Object, private elementRef: ElementRef) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngAfterViewInit(): void {
    if (!this.isBrowser) {
      return;
    }

    if (this.executeOnInit) {
      this.setImageClass();
    }
  }

  @HostListener('window:resize')
  public setImageClass(): void {
    this.element = this.elementRef.nativeElement as HTMLElement;
    this.element.classList.remove('large');
    this.element.classList.add('zoom');
    const cssHeight = parseInt(this.element.style.getPropertyValue('height'), 10);
    const elementHeight = Number.isNaN(cssHeight) ? this.element.clientHeight : cssHeight;
    const elementWidth = this.element.clientWidth;

    const p = this.picture as Picture;

    const elementRatio = elementWidth / elementHeight;
    const pictureRatio = p.width / p.height;

    if (pictureRatio > elementRatio) {
      this.element.classList.add('large');
    }
  }
}
